import { Chart } from "react-chartjs-2";

export const registerBackgroundColourService = () =>
  Chart.pluginService.register({
    beforeDraw: chart => {
      if (
        chart.config.options.chartArea &&
        chart.config.options.chartArea.backgroundColor
      ) {
        // eslint-disable-next-line
        const helpers = Chart.helpers;
        // eslint-disable-next-line
        const ctx = chart.chart.ctx;
        // eslint-disable-next-line
        const chartArea = chart.chartArea;

        ctx.save();
        ctx.fillStyle = chart.config.options.chartArea.backgroundColor;
        ctx.fillRect(
          chartArea.left,
          chartArea.top,
          chartArea.right - chartArea.left,
          chartArea.bottom - chartArea.top
        );
        ctx.restore();
      }
    },
  });



// WEBPACK FOOTER //
// ./src/lib/chartUtils.js